import styles from "./HowItWorks.module.scss";

const howitworksContent = [
  {
    icon: "https://johnlewis.scene7.com/is/image/JohnLewis/getaquote",
    title: "Get a quote",
    text: "Answer some questions about your device. We'll give you a quote which you can add to your basket.",
  },
  {
    icon: "https://johnlewis.scene7.com/is/image/JohnLewis/addapurchase_icon",
    title: "Add a purchase",
    text: "Trade In is only available with a purchase so add your chosen item to your basket",
  },
  {
    icon: "https://johnlewis.scene7.com/is/image/JohnLewis/checkout",
    title: "Checkout your order",
    text: "Our trade-in partner Likewize will tell you how to send your device. Payout can take up to 3 working days once your device is received and assessed.",
  },
];

const HowItWorks = () => {
  return (
    <div className={styles.howItWorks}>
      <h2 className={styles.howItWorks__header}>How it works</h2>
      <div className={styles.howItWorks__contentWrapper}>
        {howitworksContent.map(({ icon, title, text }, index) => (
          <div className={styles.howItWorks__contentRow} key={index}>
            <div className={styles.howItWorks__leftCol}>
              <img src={icon} alt={title} />
            </div>
            <div className={styles.howItWorks__rightCol}>
              <h4 className={styles.howItWorks__title}>{title}</h4>
              <p>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default HowItWorks;
